// ======================================================================
// File Name       : RegistrationCourseListSelection
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Col, Button, Modal, Table } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE, RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import PaginationCustom from '../Pagination';
import TableHead, { setSortState } from '../TableHead';
import { getItemBoxName } from '../../utils/index';
import * as DistributionAction from '../../actions/ContentDistributionAction';
import MessageSearch from '../../components/MessageSearch';
import CustomButton from '../button/CustomButton';

class RegistrationCourseListSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courseName: '',
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      ascendingDescendingSort: 0,
      courseSortType: null,

      courseList: [],
      recordNum: 0,
      isAllowShowSearchMessage: false,
      isInit: true,
      selectedList: [],
    };
    this.validation = this.validation.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.searchCourse = this.searchCourse.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleIsChecked = this.handleIsChecked.bind(this);
  }

  /**
   * componentDidMount event executed after first render
   */
  componentDidMount() {
    this.searchCourse();
  }

  componentWillReceiveProps(nextProps) {
    const { contentDistribution } = nextProps;
    if (!contentDistribution || !contentDistribution.distributionOfferList) {
      return;
    }
    const { distributionOfferList } = contentDistribution;
    const {
      courseSearchResult,
      distributionCourseList,
     } = distributionOfferList;
    if (courseSearchResult) {
      const { courseList, recordNum } = courseSearchResult;
      this.setState({ courseList, recordNum });
    }
  }

  searchCourse() {
    if (!this.validation()) {
      return;
    }
    const {
      courseName,
      courseSortType,
      ascendingDescendingSort,
      startPosition,
      returnMaxNum } = this.state;
    const params = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        courseName: courseName || null,
        courseSortType,
        ascendingDescendingSort,
        startPosition,
        returnMaxNum,
      },
    };
    this.props.dispatch(
      DistributionAction.getCourseList(params),
    ).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  handleSearch() {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        startPosition: 0,
        isAllowShowSearchMessage: false,
        isInit: false,
      }, () => {
        this.searchCourse();
      });
    }
  }

  getStartEndData(startPosition) {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        startPosition,
        isInit: false,
      }, () => {
        this.searchCourse();
      });
    }
  }

  handleSortState(row) {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        ascendingDescendingSort: row.sortState,
        courseSortType: row.sortBy,
        isInit: false,
      }, () => {
        this.searchCourse();
      });
    }
  }

  handleCheckbox(id, event) {
    const { courseList, selectedList } = this.state;
    for (const course of courseList) {
      if (course.courseSecernId && course.courseSecernId === id) {
        course.isChecked = course.isChecked ? !course.isChecked : true;
        if (course.isChecked) {
          selectedList.unshift(course);
        } else {
          for (let i = 0; i < selectedList.length; i++) {
            if (selectedList[i].courseSecernId === id) {
              selectedList.splice(i, 1);
            }
          }
        }
      }
    }
    this.setState({ courseList });
  }

  handleCheckAll() {
    const { courseList, selectedList } = this.state;
    let selectedCheck = [];
    const checkQuestionIdChecked = [];
    if (selectedList && selectedList.length) {
      selectedCheck = selectedList.reduce((acc, cur) => {
        if (cur.courseSecernId) {
          acc.push(cur.courseSecernId);
        }
        return acc;
      }, []);
    }
    if (courseList && courseList.length) {
      courseList.map((course) => {
        const pos = selectedCheck.indexOf(course.courseSecernId);
        if (pos > -1) {
          checkQuestionIdChecked.push(pos);
        }
      });
      if (checkQuestionIdChecked.length === courseList.length) {
        // uncheckAll
        courseList.map((course) => {
          const pos = selectedCheck.indexOf(course.courseSecernId);
          if (pos > -1) {
            course.isChecked = false;
            selectedCheck.splice(pos, 1);
            selectedList.splice(pos, 1);
          }
          return null;
        });
        this.setState({
          courseList,
          selectedList,
        });
        return;
      }
      courseList.map((course) => {
        if (selectedCheck.indexOf(course.courseSecernId) < 0) {
          course.isChecked = true;
          selectedList.unshift(course);
        }
        return null;
      });
      this.setState({
        courseList,
        selectedList,
      });
    }
  }

  handleIsChecked(courseList, selectedCourestList, isDisabled) {
    if (
      courseList &&
      courseList.length &&
      selectedCourestList &&
      selectedCourestList.length
    ) {
      const selectedList = selectedCourestList.reduce((acc, cur) => {
        if (cur.courseSecernId) {
          acc.push(cur.courseSecernId);
        }
        return acc;
      }, []);
      for (let i = 0; i < courseList.length; i++) {
        const index = selectedList.indexOf(courseList[i].courseSecernId);
        if (index > -1) {
          if (!courseList[i].isChecked) {
            courseList[i].isChecked = true;
            courseList[i].isDisabled = isDisabled;
          }
        }
      }
    }
    return courseList;
  }

  /**
   * Handle event when click on OK of  dialog
   */
  onOk() {
    let courseList = [];
    let courseCheck = [];
    if (this.props.contentDistribution && this.props.contentDistribution.distributionOfferList
      && this.props.contentDistribution.distributionOfferList.distributionCourseList
      && this.props.contentDistribution.distributionOfferList.distributionCourseList.length) {
      courseList = this.props.contentDistribution.distributionOfferList.distributionCourseList;
      courseCheck = courseList.reduce((acc, cur) => {
        if (cur.courseSecernId) {
          acc.push(cur.courseSecernId);
        }
        return acc;
      }, []);
    }
    if (this.state.selectedList && this.state.selectedList.length) {
      this.state.selectedList.map((selectedItem) => {
        const pos = courseCheck.indexOf(selectedItem.courseSecernId);
        if (pos < 0) {
          courseList.push(selectedItem);
        }
      });
    }
    this.props.onDialogOK(courseList);
  }

  /**
   * Handle event when click on cancel of  dialog
   */
  onCancel() {
    this.setState({ selectedList: [] });
    this.props.onDialogCancel();
  }

  /**
 * Handle change input field
 *
 * @param {*} event
 */
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const thead = [
      { title: '', sortBy: null, width: 50 },
      { title: 'コース名', sortBy: 1 },
    ];
    this.refsToValidate = [];
    let courseSearchResultTableData = null;
    const {
      showModal,
    } = this.props;
    const {
      courseName,
      startPosition,
      returnMaxNum,
      ascendingDescendingSort,
      courseSortType,
      courseList,
      recordNum,
      selectedList,
    } = this.state;
    let isExistCourseChecked = [];
    if (this.props.contentDistribution && this.props.contentDistribution.distributionOfferList
      && this.props.contentDistribution.distributionOfferList.distributionCourseList
      && this.props.contentDistribution.distributionOfferList.distributionCourseList.length) {
      isExistCourseChecked = this.props.contentDistribution.distributionOfferList.distributionCourseList;
    }
    let list = [];
    list = this.handleIsChecked(
      courseList,
      isExistCourseChecked,
      true,
    );
    // set is checked for selected course temporary
    list = this.handleIsChecked(
      courseList,
      selectedList,
      false,
    );
    if (list && list.length) {
      courseSearchResultTableData = list.map(
      (course, index) => (
        <tr key={index}>
          <td>
            <Form.Check
              type='checkbox'
              className="padding-clear margin-top-4"
              checked={
                  course.isChecked ? course.isChecked : false
                }
              onChange={this.handleCheckbox.bind(
                  this,
                  course.courseSecernId,
                )}
              disabled={course.isDisabled || false} />
          </td>
          <td>
            {course.courseName}
          </td>
        </tr>
        ),
      );
    }
    let data = thead;
    if (this.state) {
      const sortBy = this.state.courseSortType;
      const sortState = this.state.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={'lg'}
        style={style}
        dialogClassName="course-distribution-offer-list-dialog"
      >
        <Modal.Header onHide={this.onCancel} closeButton>
          <Modal.Title className="text-center">
            配布するコースを選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <MessageSearch
              recordNum={recordNum}
              resultList={courseList}
              isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
              dismissMessage={this.dismissMessage}
            />
            <Form onSubmit={(e) => { e.preventDefault(); this.handleSearch(); }} className='form-horizontal'>
              <Form.Group
                className="form-info"
                controlId="formHorizontalDialogCourseName"
              >
                <Col as={Form.Label} sm={4}>
                  コース名
                </Col>
                <Col sm={6}>
                  <FormControl
                    type="text"
                    maxLength="256"
                    name="courseName"
                    value={courseName || ''}
                    onChange={this.handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col className="text-center">
                  {/* <Button
                    bsStyle="primary"
                    className="btn-96 text-center"
                    type="submit"
                  >
                  </Button> */}
                  <CustomButton
                    btnStyle="btn btn-primary btn-96"
                    type="submit"
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Form.Group>
              <Col sm={2}>
                <Button variant="default" onClick={this.handleCheckAll}>
                  全選択/解除
                </Button>
              </Col>
              <Col sm={10}>
                <PaginationCustom
                  className="float-end"
                  recordNum={recordNum}
                  handlePageSelect={this.getStartEndData}
                  startPosition={startPosition}
                />
              </Col>
              <Col>
                <Table striped hover className="margin-top-10">
                  <thead>
                    <TableHead data={thead} handleSortState={this.handleSortState} />
                  </thead>
                  <tbody>
                    {courseSearchResultTableData}
                  </tbody>
                </Table>
              </Col>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button
            variant="default"
            className="margin-right-10 btn-96"
            onClick={this.onCancel}
          >
            キャンセル
          </Button>
          <Button
            className=" margin-left-10 btn-96"
            variant="primary"
            onClick={this.onOk}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ contentDistribution: state.contentDistribution },
});

export default connect(mapStateToProps)(RegistrationCourseListSelection);
